import { sessionPrefix } from "./helpers";

export const knowledgebaseNgPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/knowledgebase-ng`;

export const showKnowledgebaseNgArticlePath = (session: LightSessionInterface, article: KnowledgebaseNgArticleRef) =>
  `${sessionPrefix(session)}/knowledgebase-ng/${article.id}`;
export const editKnowledgebaseNgArticlePath = (session: LightSessionInterface, article: KnowledgebaseNgArticleRef) =>
  `${sessionPrefix(session)}/knowledgebase-ng/${article.id}/edit`;
export const newKnowledgebaseNgArticlePath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/knowledgebase-ng/new`;

export const knowledgebaseNgCategoriesPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/knowledgebase-ng/categories`;

export const newKnowledgebaseNgCategoryPath = (
  session: LightSessionInterface,
  parentCategory?: KnowledgebaseNgCategoryRef,
) => {
  let qs = "";

  if (parentCategory) {
    qs = `?parentId=${parentCategory.id}`;
  }

  return `${sessionPrefix(session)}/knowledgebase-ng/categories/new${qs}`;
};

export const editKnowledgebaseNgCategoryPath = (session: LightSessionInterface, category: KnowledgebaseNgCategoryRef) =>
  `${sessionPrefix(session)}/knowledgebase-ng/categories/${category.id}`;
